// extracted by mini-css-extract-plugin
module.exports = {"redirectContainer":"styles_redirectContainer__mU-jf"};